import {combineReducers} from '@modifi/redux'
import tasksReducer from './tasks/collection'

export default combineReducers({
  tasks: tasksReducer,
})
